module.exports = __webpack_public_path__ + "static/media/BTS_FINALS-4.f341330e.jpg";